import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import ProjetoCulturalLogged from '../../../components/auth/projetocultural'

function ProjetoCulturalLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Projetos Culturais" />
                <HeaderLogged />
                <Container>
                   <ProjetoCulturalLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default ProjetoCulturalLoggedScreen;